export function trackEvent(event_name, event_params) {
  if (process.env.NODE_ENV !== 'production' || !window.gtag) {
    console.log(arguments)
    return
  }

  window.gtag('event', event_name, event_params)
}

export function trackEventBasic(event_category, event_action, event_label, value) {
  if (process.env.NODE_ENV !== 'production' || !window.gtag) {
    console.log(arguments)
    return
  }

  window.gtag('event', event_action, {
    event_category,
    event_label,
    value
  })
}



// WEBPACK FOOTER //
// ./src/services/AnalyticsWrapper.js